//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue'
import vueQR from '~/components/common/vueQR.vue' // 二维码
import help from '~/components/vps/help' // 快速帮助
import { matomofn } from '~/assets/js/utils.js'
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    help,
    vueQR
  },
  async asyncData ({ $api, store, redirect, route }) {
    try {
      const {
        locale = 'en',
        cookieVal = '',
        simpleUser = {},
        countryCode
      } = store.state
      const code = route.params?.id?.split('.')[0] || ''
      const id = route.query?.code
      let obj = {}
      if (cookieVal) {
        // 用户已登录
        const userId = simpleUser?.userId
        const uHost = await $api.burstData.newUserHost({
          UserId: Number(userId)
        })
        if (uHost?.length) return redirect(`/${locale}/jyzh`) // 用户拥有购买的VPS主机，跳转至对应页面
      }
      // const { typeList: regionInfo = [] } = await $api.burstData.newRegionInfoV2Service({ ip })
      // console.log({ brokerId: id }, '参数')
      if (id) {
        const res2 = await $api.common
          .v3Server(
            { Routes: 'cloudvpsapi$regioninfofornewprovps' },
            { brokerId: id }
          )
          .catch(() => {})
        const regionInfo2 =
          res2?.cloudvpsapi?.regioninfofornewprovps?.data?.typeList[0]
        obj = regionInfo2
        console.log(111)
      } else {
        const res = await $api.common
          .v3Server(
            { Routes: 'cloudvpsapi$regioninfov2' },
            { apiCountryCode: countryCode, apiLanguage: locale }
          )
          .catch(() => {})
        const regionInfo = res?.cloudvpsapi?.regioninfov2?.data?.typeList || []
        regionInfo?.forEach((item) => {
          if (id && item.BrokerId == id) {
            obj = item
          }
          if (!id && item?.Config == code) {
            obj = item
          }
        })
        console.log(222)
      }
      if (!obj?.title) return redirect(`/${locale}/vps.html`)
      return {
        obj
      }
    } catch (error) {}
  },
  data () {
    return {
      isShow: false,
      scanPop: false // app下载弹窗显示隐藏
    }
  },
  head () {
    let [title, content] = ['', '']
    if (this.obj?.Config == 1) {
      title = this.$t('23002')
      content = this.$t('23006')
    } else if (this.obj?.Config == 2) {
      title = this.$t('22998')
      content = this.$t('23007')
    } else if (this.obj?.Config == 3) {
      title = this.$t('24684')
      content = this.$t('24685')
    } else {
      title = this.$t('23000').replace(/\{0}/g, this.obj?.BrokerName)
      content = this.$t('23001').replace(/\{0}/g, this.obj?.BrokerName)
    }
    return {
      title,
      meta: [{ name: 'Description', content }]
    }
  },
  computed: {
    // 是否为移动端
    isM () {
      return this.$store.state?.isMobile
    },
    // “扫码下载”背景图
    scanBg () {
      return !this.$store.state?.isChina
        ? 'https://resources.interface003.com/cloud/img/eashop/scan-bg.svg'
        : 'https://resources.interface003.com/cloud/img/eashop/scan-bg-cn.png'
    },
    breadHost () {
      return this.$store.getters.breadHome
    }
  },
  watch: {
    '$store.state.cookieVal' (val) {
      if (val) window?.location?.reload()
    }
  },
  mounted () {},
  methods: {
    showPop (cofing) {
      matomofn('VPS_Open', {}, this.$store.state, this.$cookies)
      if (!this.isM) this.scanPop = true
      else this.todown(cofing, '')
    },

    todown (config, traderCode) {
      const ua = navigator.userAgent.toLowerCase()
      const isAndroid = ua.includes('android') || ua.includes('linux')
      /** fxeyemaster海外版 fxeyechinesemaster中文版 */
      if (isAndroid) {
        // console.log('isAndroid')
        const iframe = document.createElement('iframe')
        iframe.src = `wikifx://tans?config=${config}&traderCode=${traderCode}&appjumptype=9999`
        iframe.style.display = 'none'
        document.body.appendChild(iframe)

        setTimeout(() => {
          window.location = `${this.breadHost}download.html`
        }, 3000)
      } else {
        window.location = `wikifx://tans?config=${config}&traderCode=${traderCode}&appjumptype=9999`
        setTimeout(() => {
          window.location = `${this.breadHost}download.html`
        }, 2000)
      }
    }
  }
}
